module.exports = {
      id: "tick-usage",
      viewBox: "0 0 23.788 23.787",
      url: "/" + "sprite-e509a544a5c47560e0a2aa1e13829d5a.svg#tick",
      toString: function () {
        return this.url;
      }
    }